<template>
  <div style="padding-top: 20px" class="mb-5 policy-info">
    <keep-alive>
      <router-view
        :isLoading="isLoading"
        :isAllLoading="isAllLoading"
        :allFamilyDatas="allFamilyDatas"
        :getCathayInsuranceResult="getCathayInsuranceResult"
        :getOtherInsuranceResult="getOtherInsuranceResult"
        :getGroupInsuranceResult="getGroupInsuranceResult"
        ></router-view>
        <!-- :getCustInsurance_CCIPLN4MVResult="getCustInsurance_CCIPLN4MVResult"
        :getCustInsurance_CCIPLN2MVResult="getCustInsurance_CCIPLN2MVResult"
        :getCustInsurance_CCIPLN1MVResult="getCustInsurance_CCIPLN1MVResult"
        :getCustInsurance_CCIPLC1MVResult="getCustInsurance_CCIPLC1MVResult"
        :getCustInsurance_CCIPLF1MVResult="getCustInsurance_CCIPLF1MVResult"
        :getOtherPropertyInsuranceResult="getOtherPropertyInsuranceResult" -->
    </keep-alive>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { mapMutations, mapGetters } from "vuex";

import {
  getCathayInsurance,
  getOtherInsurance,
  getGroupInsurance,
  // getOtherPropertyInsurance,
  // getCustInsurance_CCIPLN4MV,
  // getCustInsurance_CCIPLN2MV,
  // getCustInsurance_CCIPLN1MV,
  // getCustInsurance_CCIPLC1MV,
  // getCustInsurance_CCIPLF1MV,
  getAllFamily,
} from "@/service";

const EMPTY_CATHAY_PROPERTY_INSURANCE = { policies: [], policiesSelfInput: [] };

export default {
  name: "bkPolicyInfo",
  mixins: [commonMixin],
  data() {
    return {
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      allFamily: null,
      allFamilyDatas: [],
      //前頁FAMILY DATA
      familyData: JSON.parse(localStorage.userItems),
      //是否顯示查詢GIF
      isLoading: true,
      isAllLoading: true,
      //國泰壽險資料
      getCathayInsuranceResult: [],
      //同業/建議書
      getOtherInsuranceResult: {},
      //團險
      getGroupInsuranceResult: [],
      //其他產險
      // getOtherPropertyInsuranceResult: {},
      //國壽健康險
      // getCustInsurance_CCIPLN4MVResult: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽傷害險
      // getCustInsurance_CCIPLN2MVResult: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽新種險
      // getCustInsurance_CCIPLN1MVResult: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽車險
      // getCustInsurance_CCIPLC1MVResult: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽火險
      // getCustInsurance_CCIPLF1MVResult: EMPTY_CATHAY_PROPERTY_INSURANCE,

      //是否為保代用頁面
      isFromBank: true,
    };
  },
  methods: {
    ...mapMutations(["updateAllFamilyResult", "updateFamilyResultFilter"]),
    ...mapGetters(["AllFamilyResult", "FamilyResultFilter"]),
    async mygetCathayInsurance() {
      const result = await getCathayInsurance(
        this.agidno,
        this.allFamily,
        this.isFromBank
      ).catch(() => (this.isLoading = false));
      this.getCathayInsuranceResult = result.data || [];
      this.isLoading = false;
    },
    async mygetOtherInsurance() {
      const result = await getOtherInsurance(
        this.agidno,
        this.allFamily,
        this.isFromBank
      );
      this.getOtherInsuranceResult = result.data || {};
    },
    async mygetGroupInsurance() {
      const result = await getGroupInsurance(this.agidno, this.allFamily);
      this.getGroupInsuranceResult = result.group || [];
    },
    // async mygetCathayHelthInsurance() {
    //   const result = await getCustInsurance_CCIPLN4MV(
    //     this.agidno,
    //     this.allFamily
    //   );
    //   this.getCustInsurance_CCIPLN4MVResult =
    //     result.body || EMPTY_CATHAY_PROPERTY_INSURANCE;
    // },
    // async mygetCathayHurtInsurance() {
    //   const result = await getCustInsurance_CCIPLN2MV(
    //     this.agidno,
    //     this.allFamily
    //   );
    //   this.getCustInsurance_CCIPLN2MVResult =
    //     result.body || EMPTY_CATHAY_PROPERTY_INSURANCE;
    // },
    // async mygetCathayNewInsurance() {
    //   const result = await getCustInsurance_CCIPLN1MV(
    //     this.agidno,
    //     this.allFamily
    //   );
    //   this.getCustInsurance_CCIPLN1MVResult =
    //     result.body || EMPTY_CATHAY_PROPERTY_INSURANCE;
    // },
    // async mygetCathayCarInsurance() {
    //   const result = await getCustInsurance_CCIPLC1MV(
    //     this.agidno,
    //     this.allFamily
    //   );
    //   this.getCustInsurance_CCIPLC1MVResult =
    //     result.body || EMPTY_CATHAY_PROPERTY_INSURANCE;
    // },
    // async mygetCathayFireInsurance() {
    //   const result = await getCustInsurance_CCIPLF1MV(
    //     this.agidno,
    //     this.allFamily
    //   );
    //   this.getCustInsurance_CCIPLF1MVResult =
    //     result.body || EMPTY_CATHAY_PROPERTY_INSURANCE;
    // },
    // async mygetOtherPropertyInsurance() {
    //   const result = await getOtherPropertyInsurance(
    //     this.agidno,
    //     this.allFamily,
    //     this.isFromBank
    //   );
    //   this.getOtherPropertyInsuranceResult = result.data || {};
    // },
    getAllInsurance() {
      //壽險
      Promise.all([
        this.mygetCathayInsurance(),
        //同業、建議書
        this.mygetOtherInsurance(),
        //團險
        this.mygetGroupInsurance(),
        //-----------------------------國壽產險-----------------------------
        //健康險
        // this.mygetCathayHelthInsurance(),
        //傷害險
        // this.mygetCathayHurtInsurance(),
        //新種險
        // this.mygetCathayNewInsurance(),
        //車險
        // this.mygetCathayCarInsurance(),
        //火險
        // this.mygetCathayFireInsurance(),
        //-----------------------------國壽產險-----------------------------
        //其他產險
        // this.mygetOtherPropertyInsurance(),
      ]).finally(() => (this.isAllLoading = false));
    },
    async callApi(fn, done) {
      await fn();
      done();
    },
    init() {
      // 初始化

      if (this.AllFamilyResult().length || this.FamilyResultFilter().length) {
        localStorage.AllFamilyResult = JSON.stringify(this.AllFamilyResult());
        localStorage.FamilyResultFilter = JSON.stringify(
          this.FamilyResultFilter()
        );
      } else {
        this.updateAllFamilyResult(JSON.parse(localStorage.AllFamilyResult));
        this.updateFamilyResultFilter(
          JSON.parse(localStorage.FamilyResultFilter)
        );
      }
      new Promise((resolve) => {
        //this.updateAllFamilyResult(localStorage.allFamily )
        //          this.updateFamilyResultFilter(localStorage.allFamilyFilter)

        if (localStorage.allFamily) {
          // this.allFamily = localStorage.allFamily.split(',');
          // this.allFamilyDatas = JSON.parse(localStorage.allFamilyDatas)
          getAllFamily(
            this.familyData.agidno,
            this.familyData.csidno,
            this.isFromBank
          ).then((result) => {
            this.allFamily = localStorage.allFamily.split(",");
            this.allFamilyDatas = result.data;
            this.getAllInsurance();
            resolve();
          });
        } else {
          //   取得所有名單
          getAllFamily(
            this.familyData.agidno,
            this.familyData.csidno,
            this.isFromBank
          ).then((result) => {
            this.allFamily = result.data.map((x) => x.csidno);
            this.allFamilyDatas = result.data;
            localStorage.allFamily = this.allFamily;

            // localStorage.allFamilyDatas = JSON.stringify(this.allFamilyDatas)
            this.getAllInsurance();
            resolve();
          });
        }
      })
        .then(() => {
          // event listener
          this.$bus.on("cathay-life-insurance.get", (done) =>
            this.callApi(this.mygetCathayInsurance, done)
          );
          this.$bus.on("other-life-insurance.get", (done) =>
            this.callApi(this.mygetOtherInsurance, done)
          );
          this.$bus.on("group-insurance.get", (done) =>
            this.callApi(this.mygetGroupInsurance, done)
          );
          // this.$bus.on("cathay-health-insurance.get", (done) =>
          //   this.callApi(this.mygetCathayHelthInsurance, done)
          // );
          // this.$bus.on("cathay-hurt-insurance.get", (done) =>
          //   this.callApi(this.mygetCathayHurtInsurance, done)
          // );
          // this.$bus.on("cathay-new-insurance.get", (done) =>
          //   this.callApi(this.mygetCathayNewInsurance, done)
          // );
          // this.$bus.on("cathay-car-insurance.get", (done) =>
          //   this.callApi(this.mygetCathayCarInsurance, done)
          // );
          // this.$bus.on("cathay-fire-insurance.get", (done) =>
          //   this.callApi(this.mygetCathayFireInsurance, done)
          // );
          // this.$bus.on("other-property-insurance.get", (done) =>
          //   this.callApi(this.mygetOtherPropertyInsurance, done)
          // );
          this.$once("hook:destroyed", () => {
            this.$bus.off("cathay-life-insurance.get");
            this.$bus.off("other-life-insurance.get");
            this.$bus.off("group-insurance.get");
            // this.$bus.off("cathay-health-insurance.get");
            // this.$bus.off("cathay-hurt-insurance.get");
            // this.$bus.off("cathay-new-insurance.get");
            // this.$bus.off("cathay-car-insurance.get");
            // this.$bus.off("cathay-fire-insurance.get");
            // this.$bus.off("other-property-insurance.get");
          });
        })
        .finally(() => {
          this.registerHanlink(); // for 難字更新
          //更新重新載入參數
          this.$route.meta.reload = false;
        });
    },
    initData() {
      //業務員ID
      this.agidno = this.$store.state.userInfo.id;
      this.allFamily = null;
      //前頁FAMILY DATA
      this.familyData = JSON.parse(localStorage.userItems);
      //是否顯示查詢GIF
      this.isLoading = true;
      this.isAllLoading = true;
      //國泰壽險資料
      this.getCathayInsuranceResult = [];
      //同業/建議書
      this.getOtherInsuranceResult = {};
      //團險
      this.getGroupInsuranceResult = [];
      //其他產險
      // this.getOtherPropertyInsuranceResult = {};
      //國壽健康險
      // this.getCustInsurance_CCIPLN4MVResult = EMPTY_CATHAY_PROPERTY_INSURANCE;
      //國壽傷害險
      // this.getCustInsurance_CCIPLN2MVResult = EMPTY_CATHAY_PROPERTY_INSURANCE;
      //國壽新種險
      // this.getCustInsurance_CCIPLN1MVResult = EMPTY_CATHAY_PROPERTY_INSURANCE;
      //國壽車險
      // this.getCustInsurance_CCIPLC1MVResult = EMPTY_CATHAY_PROPERTY_INSURANCE;
      //國壽火險
      // this.getCustInsurance_CCIPLF1MVResult = EMPTY_CATHAY_PROPERTY_INSURANCE;
    },
  },
  mounted() {
    this.init();
  },
  activated() {
    //判斷是否需刷新
    //確保資料參數更新後再執行init方法
    if (this.$route.meta.reload) {
      new Promise((resolve) => {
        this.initData();
        resolve();
      }).then(() => {
        this.init();
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.policy-info /deep/ {
  .thBorderCustOther {
    height: 48px;
    border: #0f82b5 1px solid !important;
  }
  .thBorderCustSuggest {
    height: 48px;
    border: #de4054 1px solid !important;
  }
  .pre-formatted {
    white-space: pre-line;
  }
  .policyBlue {
    color: #1442c4;
  }
  .primary {
    background-color: white;
  }
  .fw-normal {
    font-weight: normal;
  }
  .font-13 {
    font-size: 13px;
  }
  .font-20 {
    font-size: 20px;
  }
  .table.datatable tbody tr.bg-orange {
    background: #feeedd;
  }
  .margin-vertical-5 {
    margin-bottom: 25px;
  }
}
</style>
